export { default, StyledAdditionalInfo } from './AdditionalInfo';
export type { AdditionalInfoProps } from './AdditionalInfo';
